var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkyBlueIndicatorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4H40.37V24.35C40.37 27.6732 39.0499 30.8602 36.7 33.21C34.3502 35.5599 31.1632 36.88 27.84 36.88H21.53C18.2068 36.88 15.0198 35.5599 12.67 33.21C10.3201 30.8602 9 27.6732 9 24.35V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.37 8V24.36C36.3673 26.6215 35.4678 28.7896 33.8687 30.3887C32.2695 31.9878 30.1014 32.8874 27.84 32.89H21.53C19.2685 32.8874 17.1003 31.9878 15.5012 30.3887C13.9021 28.7896 13.0026 26.6215 13 24.36V8H36.37ZM40.37 4H9V24.36C9 27.6832 10.3201 30.8702 12.6699 33.2201C15.0198 35.5699 18.2069 36.89 21.53 36.89H27.84C31.1631 36.89 34.3502 35.5699 36.7001 33.2201C39.0499 30.8702 40.37 27.6832 40.37 24.36V4Z",
    fill: "#28AEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.5992 11.8516V23.8015C32.6006 24.49 32.4659 25.172 32.203 25.8084C31.9401 26.4447 31.5542 27.0229 31.0674 27.5097C30.5805 27.9966 30.0024 28.3825 29.3661 28.6454C28.7297 28.9083 28.0477 29.0429 27.3593 29.0416H22.0193C21.0003 29.0427 20.0031 28.7461 19.1504 28.1883C18.2977 27.6304 17.6264 26.8356 17.2192 25.9016H24.7092V22.2016H16.7793V18.8316H24.7092V15.1316H16.7793V11.8516H32.5992Z",
    fill: "#28AEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6895 34.8516H22.6895V45.0516H26.6895V34.8516Z",
    fill: "#28AEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyBlueIndicatorIcon);
export default __webpack_public_path__ + "static/media/SkyBlueIndicatorIcon.648bc034f717a96af5c42a990aaaff63.svg";
export { ForwardRef as ReactComponent };